var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "white",
    stroke: "#EAEAEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2267 12.6673C10.8414 11.6026 11.7386 10.7285 12.8191 10.1419C13.8996 9.55521 15.1213 9.27878 16.3491 9.34312C17.5769 9.40747 18.763 9.81009 19.7762 10.5065C20.7895 11.2029 21.5904 12.1659 22.0905 13.2891M8.69336 10.5968L9.3012 13.2297C9.40473 13.6782 9.85219 13.9578 10.3006 13.8543L12.9336 13.2464M21.7737 19.3339C21.159 20.3987 20.2618 21.2727 19.1813 21.8593C18.1008 22.446 16.8791 22.7224 15.6513 22.6581C14.4235 22.5937 13.2374 22.1911 12.2242 21.4947C11.2109 20.7983 10.41 19.8353 9.90991 18.7121M23.307 21.4044L22.6992 18.7715C22.5957 18.323 22.1482 18.0434 21.6998 18.147L19.0668 18.7548",
    stroke: "#7D899C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.fe31d11a17a1178f575832b0b552d488.svg";
export { ForwardRef as ReactComponent };